import { Route, Switch } from "react-router-dom";
import OfferProductsExporter from "./OfferProductsExporter";
import OfferProductDetailsExporter from "./OfferProductDetailsExporter";
import OfferProductViewExporter from "./OfferProductViewExporter";

const App = ({ match }) => (
  <Switch>
    <Route exact path={`${match.url}`} component={OfferProductsExporter} />
    <Route path={`${match.url}/view/:id?`} component={OfferProductViewExporter}/>
    <Route
      path={`${match.url}/add-edit/:id?`}
      component={OfferProductDetailsExporter}
    />
  </Switch>
);

export default App;
